







import { Component, Vue, Prop } from 'vue-property-decorator';
import { TagType } from './index';
import ClockSvg from './icon/clock.svg';
import HotSvg from './icon/hot.svg';
import StampSvg from './icon/stamp.svg';
import LabelSvg from './icon/label.svg';

@Component({
  components: {},
})
export default class Tag extends Vue {
  @Prop() type!: TagType;
  @Prop() text!: string;

  public styleMap = {
    [TagType.Hot]: {
      icon: HotSvg,
      color: '#FA5151',
    },
    [TagType.Clock]: {
      icon: ClockSvg,
      color: '#FA9D3B',
    },
    [TagType.Stamp]: {
      icon: StampSvg,
      color: '#07C160',
    },
    [TagType.Label]: {
      icon: LabelSvg,
      color: '#1485EE',
    },
  };

  /** tag的icon图片 */
  get icon() {
    return this.styleMap[this.type].icon;
  }
  /** tag颜色 */
  get colorVal() {
    return this.styleMap[this.type].color;
  }
  /** tag边框颜色 */
  get borderStyle() {
    return {
      borderColor: this.colorVal,
    };
  }
  /** tag字体颜色 */
  get colorStyle() {
    return {
      color: this.colorVal,
    };
  }
}
